import styled, { css } from 'styled-components';

export const MainText = styled.div`
  text-align: ${({textAlign}) => textAlign || 'center'};
  font-size: 12px;
  line-height: 1.31;
  color: ${({color}) => color};
  ${({margin}) => margin && css`margin: ${margin}`};
`
